// Hooks
import { createFormContext, useForm } from 'hooks';

export const FamilyContext = createFormContext();

export const useFamily = useForm;
export default useFamily;
